export const LOGIN_CLEAR = 'LOGIN_CLEAR';
export const LOGIN_CLEAR_ERROR = 'LOGIN_CLEAR_ERROR';
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_REQUIRE_MFA = 'LOGIN_REQUIRE_MFA';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_USER_INFO = 'LOGIN_USER_INFO';
